import { render, staticRenderFns } from "./VHeader.vue?vue&type=template&id=697fa096&scoped=true"
import script from "./VHeader.vue?vue&type=script&lang=js"
export * from "./VHeader.vue?vue&type=script&lang=js"
import style0 from "./VHeader.vue?vue&type=style&index=0&id=697fa096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697fa096",
  null
  
)

export default component.exports